import script from "./VotingWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./VotingWidget.vue?vue&type=script&setup=true&lang=js"

import "./VotingWidget.vue?vue&type=style&index=0&id=2314336e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2314336e"]])

export default __exports__